module.exports = __webpack_public_path__ + "media/components/country-flag/static/ht-ee4a6748a2cdddf5b567a3b3016f8a7d.svg";